// extracted by mini-css-extract-plugin
export default {"titleWrapper":"sGB9K0ddMdF2Nc1vGgZT","title":"DKftuYFZI_4utAtq8l0w","icon":"i_QRO4FGO4n55n2OYreN"};